var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";

import { HelpTooltip } from "../../components/HelpTooltip";

import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";

function TextFieldWidget(props) {
  var value = props.value,
      readonly = props.readonly,
      disabled = props.disabled,
      autofocus = props.autofocus,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      options = props.options,
      schema = props.schema,
      label = props.label,
      metadata = props.schema.metadata,
      formContext = props.formContext,
      registry = props.registry,
      uiSchema = props.uiSchema,
      rawErrors = props.rawErrors,
      inputProps = _objectWithoutProperties(props, ["value", "readonly", "disabled", "autofocus", "onBlur", "onFocus", "options", "schema", "label", "schema", "formContext", "registry", "uiSchema", "rawErrors"]);

  var onChange = function onChange(_ref) {
    var value = _ref.target.value;

    return props.onChange(value ? value : options.emptyValue);
  };

  return React.createElement(
    FormControl,
    {
      onChange: onChange,
      onBlur: onBlur && function (event) {
        return onBlur(inputProps.id, event.target.value);
      },
      onFocus: onFocus && function (event) {
        return onFocus(inputProps.id, event.target.value);
      },
      readOnly: metadata.readonly,
      disabled: metadata.readonly,
      required: metadata.required,
      autoFocus: autofocus,
      margin: "none",
      fullWidth: true
    },
    React.createElement(HelpTooltip, { help: metadata.help }),
    React.createElement(
      InputLabel,
      { htmlFor: inputProps.id },
      label
    ),
    React.createElement(Input, _extends({ value: value || '', type: schema.type }, inputProps))
  );
}

TextFieldWidget.defaultProps = {
  type: "text",
  required: false,
  disabled: false,
  readonly: false,
  autofocus: false
};

TextFieldWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
} : {};

export default TextFieldWidget;